import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, NotificheTipo, ModelNumStr, NotificheTipoLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class NotificheTipoService extends CrudGenericsService<NotificheTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/NotificheTipo`);
    this.base = `${env.apiUrl}/api/NotificheTipo/`;
  }
  GetInputTipGetNotificheTipo_Codicio_Codici(): Observable<ModelNumStr[]> {
    const url = this.base + 'GetNotificheTipo_Codici';
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  // web
  GetAll_NotificheTipoLng(): Observable<NotificheTipoLng[]> {
    const url = this.base + 'GetAll_NotificheTipoLng';
    return this.http.get<NotificheTipoLng[]>(`${url}`);
  }
}
